/**
 * @module mapbs.components.copytoclip.copytoclip
 */
import angular from 'angular';
import mapbsCopyToClipService from 'mapbs/components/copytoclip/copytoclipservice.js';

const moduleCopytoclip = angular.module('mapbsCopyToClipModule', [
    mapbsCopyToClipService.name,
]);

const copyToClipDir = function (mapbsCopyToClipService) {
    return {
        restrict: 'A',
        scope: {
            mapbsCopyToClip: '@',
        },
        link: function (scope, element, attrs) {
            const textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0',
            });
            element.append(textarea);
            element.bind('click', function () {
                const txt = $(this).parent().find('textarea').first();
                mapbsCopyToClipService.getCopyToClipService(attrs.mapbsCopyToClip, txt);
            });
        },
    };
};

moduleCopytoclip.directive('mapbsCopyToClip', copyToClipDir);

export default moduleCopytoclip;
